import { FormStatus } from "./enums.models";

export class ScreenValidation {
    constructor() {
        this.personal = true;
        this.employment = true;
        this.yourAccidentYourInvolvement = true;
        this.yourAccidentYourTimeLocation = true;
        this.yourAccidentDescription = true;
        this.yourInjuriesDetails = true;
        this.yourInjuriesMedicalAttention = true;
        this.yourVehicle = true;
        this.responsibleParty = true;
        this.policeAndWitnesses = true;
        this.passengers = true;
    }

    personal: boolean;
    employment: boolean;
    yourAccidentYourInvolvement: boolean;
    yourAccidentYourTimeLocation: boolean;
    yourAccidentDescription: boolean;
    yourInjuriesDetails: boolean;
    yourInjuriesMedicalAttention: boolean;
    yourVehicle: boolean;
    responsibleParty: boolean;
    passengers: boolean;
    policeAndWitnesses: boolean;
    witnesses: boolean[] = [];

    get yourDetails(): boolean {
        return this.personal && this.employment;
    }

    get yourInjuries(): boolean {
        return this.yourInjuriesDetails && this.yourInjuriesMedicalAttention;
    }

    get yourAccident(): boolean {
        return this.yourAccidentYourInvolvement && this.yourAccidentYourTimeLocation && this.yourAccidentDescription;
    }

    get involvedParties(): boolean {
        return this.responsibleParty && this.passengers && this.policeAndWitnesses;
    }
}

export class ProgressBarModel {
    yourDetails: FormStatus | undefined;
    yourAccident: FormStatus | undefined;
    yourInjuries: FormStatus | undefined;
    yourVehicle: FormStatus | undefined;
    involvedParties: FormStatus | undefined;
}
